import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var User = function User(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0107 12.1475C14.3525 12.1475 16.3398 10.0635 16.3398 7.36719C16.3398 4.73535 14.3418 2.71582 12.0107 2.71582C9.66895 2.71582 7.66016 4.76758 7.6709 7.38867C7.6709 10.0635 9.6582 12.1475 12.0107 12.1475ZM5.30762 22.1377H18.6924C20.4648 22.1377 21.0771 21.6006 21.0771 20.6123C21.0771 17.8516 17.5752 14.0488 12 14.0488C6.43555 14.0488 2.92285 17.8516 2.92285 20.6123C2.92285 21.6006 3.53516 22.1377 5.30762 22.1377Z"
  })));
};

User.displayName = 'User';
export default User;